export default __webpack_public_path__ + "static/media/ducthan.7d81a509.png";